import {get} from "lodash"

import API from "@irati/utils/services/API"
import endpoints from "../endpoints"
import {insightsErrorHandler} from "./errors"

/**
 * Submits the scheduleId, userid and test flag to the API
 * @todo "userId: get(formData, "user.uuid")" . Tightly coupled with User object. should be decoupled
 * @param survey
 * @returns {PromiseLike<T> | Promise<T>}
 *
 */
export const addUserToSchedule = (formData) => {
  const {scheduleId, tenant} = formData
  const params = {
    scheduleId,
    test: true,
    userId: get(formData, "user.uuid")
  }
  return API.post(endpoints.userSurveys(tenant), params).catch(insightsErrorHandler)
}
